import { render, staticRenderFns } from "./add-bill.vue?vue&type=template&id=5c675e43&scoped=true&"
import script from "./add-bill.vue?vue&type=script&lang=js&"
export * from "./add-bill.vue?vue&type=script&lang=js&"
import style0 from "./add-bill.vue?vue&type=style&index=0&id=5c675e43&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c675e43",
  null
  
)

export default component.exports